module.exports = __webpack_public_path__ + "img/brand11-Photo.97f2abc3.png";